import './index.css';

export type {TestimonialProps} from './Testimonial';
export {default as default, TESTIMONIAL_BACKGROUNDS} from './Testimonial';
